/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import TaskSearchForm from '../../../../../../components/Tasks/TaskSearchForm/index';

class RightSidebarSearchForm extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <TaskSearchForm {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RightSidebarSearchForm;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/_earnMoneyCommon/RightSidebarSearchForm/RightSidebarSearchForm.js